<template>
  <div class="tab-menu">
    <ul class="tab-header">
      <li
        v-for="tab in tabs"
        :class="['header-item', { active: tab.isActive }]"
      >
        <a class="header-link" :href="tab.href" @click.prevent="selectTab(tab)">
          {{ $t(tab.name) }}
        </a>
      </li>
    </ul>

    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabMenu',
  data() {
    return {
      activeItem: 'home',
      tabs: [],
    }
  },
  created() {
    this.tabs = this.$children
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name == selectedTab.name
      })

      this.$emit('changeTab', selectedTab.name)
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-menu {
  .tab-header {
    list-style: none;
    display: flex;
    align-items: center;
    column-gap: 8px;

    .header-item {
      display: flex;
      border-radius: 4px;

      &.active {
        background-color: #eee5ff;

        .header-link {
          color: #00baf2;
        }
      }

      &:hover:not(.active) {
        background-color: rgba(77, 89, 149, 0.06);
        transition: all 0.3s ease;
      }

      .header-link {
        padding: 10px 20px;
        font-size: 13px;
        line-height: 19px;
        font-weight: 500;
        color: #6c7293;
      }
    }
  }
}
</style>
